import axios from "../../department-viags/config.service";
import { RolePermissions } from "./employeeRole";
import { PermissionParams } from "./permission";

export interface Role {
  id: number;
  roleName: string;
  description: string;
  note: string;
  rolePermissions?: RolePermissions[];
}

type RoleParams = {
  roleName: string;
  description: string;
  note: string;
  permissions?: PermissionParams[];
};

export class RoleService {
  static async getList() {
    const res = await axios.get<{ data: Role[]; statusCode: number }>("/role/get-list");
    return res.data.data;
  }

  static async getListById(id: number) {
    try {
      const res = await axios.get<{ data: Role[]; statusCode: number }>(`/role/get-by-id/${id}`);
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async addRole(fields: RoleParams) {
    try {
      const res = await axios.post("/role/create", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async updateRole(fields: RoleParams) {
    try {
      const res = await axios.post("/role/update", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async deleteRole(id: number) {
    try {
      const res = await axios.delete(`/role/delete/${id}`);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }
}
